export default __webpack_public_path__ + "static/media/takeaway.31e503c8.svg";